import React from "react"
import {
  Box,
  Flex,
  Text,
  Heading,
  useColorModeValue,
  Link,
  Container,
  Stat
} from "@chakra-ui/react"
import Image from "next/image"
import Qualified from "../../public/img/business-metrics-health.png"
import MultiChannel from "../../public/img/seller-leads-advanced.png"
import Informed from "../../public/img/informed-coversation.png"
import styles from "../../styles/solutions.module.css"
import Meta from "../../components/meta/Meta"
import ButtonPrimary from "../../components/buttons/PrimaryButton"
import { CheckIcon } from "@chakra-ui/icons"
import NextLink from "next/link"
import { Accordion } from "@chakra-ui/accordion"
import AccordionMenu from "../../components/accordion/AccordionMenu"
import { serviceProvidersFaq } from "../../data/ServiceProvidersFaq"

export default function ServiceProviders() {
  const textColor = useColorModeValue("gray.500", "white")

  function ButtonClick() {
  }

  return (
    <>
      <Meta
        pageName={"Find Amazon Sellers Who Need Your Service or Product - TrackSellers"}
        description={"Looking for Amazon Sellers that need your service? We help you to find the right Amazon Seller Leads who can benefit from your service or product."}
        hrefLink={"https://www.tracksellers.com/service-providers"}
      />
      <Box className={styles.ReportMainBox}>
        <Container maxW="container.xl">
          <Box pb="1rem">
            <Box className={styles.ReportSubBox}>
              <Heading as={"h1"} mb="18px" className={styles.ReportHead} >
                Find Amazon Sellers That Need of Your Services
              </Heading>
              <Text fontSize={{ base: "1.2rem", md: "1.2rem", lg: "1.5rem" }} className={styles.ReportTextHeading} mt="1rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
                Discover Amazon sellers in need of your services and boost your client base
              </Text>
            </Box>
          </Box>
          <Box pt="0rem">
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", sm: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Qualified}
                    alt="Qualified"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Stat me="auto">
                    <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }}
                      mb={{ base: "5px", md: "10px", lg: "10px" }}
                    >
                      Get Access to Over 5 million Amazon Seller Leads
                    </Heading>
                    <Box mt="1.5rem">
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Discover 5 million Amazon seller leads, giving you a vast pool of potential clients for your service business.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Find sellers across 12 Amazon marketplaces, covering a wide range of industries and markets.
                        </Text>
                      </Flex>
                      <Flex className={styles.CardPoints}>
                        <CheckIcon
                          color="orange.300"
                          className={styles.CardPointIcons}
                        />
                        <Text className={styles.ReportFeatText} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }}>
                          Get detailed information on each seller, including contact information, business performance, and Amazon metrics.
                        </Text>
                      </Flex>
                    </Box>
                  </Stat>
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column-reverse", md: "column-reverse", lg: "row" }}>
                <Box flex="1"
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}>
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Target the Right Clients with Advanced Amazon Seller Search
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Use Advanced Seller Search to filter leads based on various attributes, such as seller rank, category, location, and more.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Customize your search to find the most relevant leads for your service offerings.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w={{ base: "100%", md: "100%", lg: "80%", xl: "80%" }} color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Save time and effort by connecting with the right clients and boosting your conversion rates.
                    </Text>
                  </Flex>
                </Box>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={MultiChannel}
                    alt="MultiChannel"
                  />
                </Box>
              </Flex>
            </Box>
            <Box>
              <Flex
                pb={{ base: "0rem", md: "2rem", lg: "2rem" }}
                pt={{ base: "1rem", md: "0rem", lg: "0rem" }}
                mb={{ base: "20px", md: "50px" }}
                display={{ base: "flex", md: "flex", lg: "flex" }}
                alignItems="center"
                direction={{ base: "column", md: "column", lg: "row" }}>
                <Box flex="1" className={styles.SellerIntelligenceReportImage}>
                  <Image
                    src={Informed}
                    alt="Informed"
                  />
                </Box>
                <Box flex="1"
                  pl={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pr={{ base: "0rem", sm: "0rem", md: "0rem", lg: "3rem" }}
                  pt={{ base: "2rem", sm: "2rem", md: "2rem", lg: "0rem" }}
                >
                  <Heading color="#243e63" fontSize={{ base: "1.2rem", md: "2rem", lg: "2rem" }} mb="15px">
                    Stay Ahead of the Competition and Adapt to Market Trends
                  </Heading>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Monitor market trends, competitors&apos; performance, and emerging opportunities to adapt your business strategies.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Leverage comprehensive seller metrics to understand the needs of your target audience and fine-tune your service offerings.
                    </Text>
                  </Flex>
                  <Flex className={styles.CardPoints}>
                    <CheckIcon
                      color="orange.300"
                      className={styles.CardPointIcons}
                    />
                    <Text w="100%" color={textColor} fontSize={{ base: "1rem", md: "1.1rem", lg: "1.1rem" }} fontWeight="400">
                      Stay ahead of the competition by targeting high-potential clients and offering tailored solutions.
                    </Text>
                  </Flex>
                </Box>
              </Flex>
            </Box>
          </Box>
        </Container>
        <Box mt="2rem" mb="2rem" textAlign="center" >
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Are you ready to supercharge your growth?
          </Text>
          <Text fontSize={{ base: "1rem", md: "1.2rem", lg: "1.2rem" }} color={textColor} className={styles.ReportText} mt="0.5rem" mb="1.5rem" maxW={{ base: "100%", md: "100%", lg: "70%" }}>
            Sign up for TrackSellers today and unlock the full potential of our comprehensive platform designed for Amazon Service and Software providers.
          </Text>
          <NextLink href={"/get-started"} passHref>
            <Link >
              <ButtonPrimary ButtonClick={ButtonClick} buttonName="Get Started" />
            </Link>
          </NextLink>
        </Box>
        <Box pt="4rem" pb="4rem" pl="15px" pr="15px" background="#fff">
          <Box className={styles.LeadFaqBox}>
            <Heading className={styles.LeadFaqHead}>
              Frequently Asked Questions
            </Heading>
            <Accordion w="100%" maxWidth="800px" allowToggle defaultIndex={[0]} allowMultiple={false}>
              {
                serviceProvidersFaq?.map((ques, index) => (
                  <AccordionMenu {...ques} key={index} />))
              }
            </Accordion>
          </Box>
        </Box>
      </Box>
    </>
  )
}